import { widgetManager } from '../src/widgetManager/index.js'
import { Sdk, setReadyForInstance } from './sdk'
import WidgetContainer from './widget-container'

export default function init() {
  const webrtcAdapter = document.createElement('script')
  webrtcAdapter.type = 'text/javascript'
  webrtcAdapter.src = 'https://webrtc.github.io/adapter/adapter-latest.js'
  document.head.appendChild(webrtcAdapter)

  const telnyx = document.createElement('script')
  telnyx.type = 'text/javascript'
  telnyx.src = 'https://cdn.jsdelivr.net/npm/@telnyx/webrtc'
  document.head.appendChild(telnyx)

  window.process = {
    env: {
      NODE_ENV: 'production',
    },
  }

  const telnyxVideo = document.createElement('script')
  telnyxVideo.type = 'text/javascript'
  telnyxVideo.src = 'https://cdn.jsdelivr.net/npm/@telnyx/video'
  document.head.appendChild(telnyxVideo)

  const emoji = document.createElement('script')
  emoji.type = 'module'
  emoji.src = 'https://cdn.jsdelivr.net/npm/emoji-picker-element@^1/index.js'
  document.head.appendChild(emoji)

  const signalR = document.createElement('script')
  signalR.type = 'text/javascript'
  signalR.src = 'https://cdnjs.cloudflare.com/ajax/libs/microsoft-signalr/8.0.7/signalr.min.js'
  document.head.appendChild(signalR)

  const slider = document.createElement('script')
  slider.src = 'https://cdn.jsdelivr.net/npm/swiffy-slider@1.6.0/dist/js/swiffy-slider.min.js'
  slider.setAttribute('data-noinit', '')
  slider.defer = true
  document.head.appendChild(slider)

  const sliderStyles = document.createElement('link')
  sliderStyles.href = 'https://cdn.jsdelivr.net/npm/swiffy-slider@1.6.0/dist/css/swiffy-slider.min.css'
  sliderStyles.rel = 'stylesheet'
  sliderStyles.setAttribute('crossorigin', 'anonymous')
  document.head.appendChild(sliderStyles)

  const selfieSegmentation = document.createElement('script')
  selfieSegmentation.type = 'text/javascript'
  selfieSegmentation.src = 'https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/selfie_segmentation.js'
  document.head.appendChild(selfieSegmentation)

  const cameraUtils = document.createElement('script')
  cameraUtils.type = 'text/javascript'
  cameraUtils.src = 'https://cdn.jsdelivr.net/npm/@mediapipe/camera_utils/camera_utils.js'
  document.head.appendChild(cameraUtils)

  function ready() {
    if (!window._cceSettings && window.Ringetic && window.Ringetic.settings) {
      window._cceSettings = window.Ringetic.settings
    }

    const elements = document.querySelectorAll('.ringetic-widget, .cce-widget')
    for (const element of elements) {
      element.classList.remove('ringetic-widget')
      element.classList.remove('cce-widget')
      element.classList.add('cce-widget-container')
    }
    if (window._cceSettings && !window.cceClient) {
      console.info('[widget] Initializing trueengage widget')
      window.cceClient = new WidgetContainer(window._cceSettings)

      let sdk = new Sdk(window.cceClient.token, window.cceClient)
      window.trueengage = sdk

      setReadyForInstance(sdk)
    } else {
      console.error('Failed to initialize CCE client. No settings provided')
    }
  }

  // Add an event listener for the "DOMContentLoaded" event
  document.addEventListener('DOMContentLoaded', ready)

  // Add an event listener for the "page:load" event
  document.addEventListener('page:load', ready)

  function onready(fn) {
    if (document.readyState !== 'loading') {
      fn()
    } else {
      document.addEventListener('DOMContentLoaded', fn)
    }
  }
  onready(ready)
}
